__turbopack_context__.v({
  "articles": "_4MyLiG_articles",
  "inverted": "_4MyLiG_inverted",
  "navbarExpanded": "_4MyLiG_navbarExpanded",
});
